const RAW_TOOL_LINE_RE =
  /^\s*(?:[-*]\s*)?(?:ask_user_input_v\d+|blueprint_request_v\d+|save_automation_profile|browser(?:_[a-z_]+)?|web_search|web_fetch|terminal|run_python|run_code|deploy_preview|write_file|read_file|list_files|mcp_call)\s*[:({[]/i

const RAW_JSON_LINE_RE =
  /^\s*(?:[-*]\s*)?[{[]\s*['"]?(?:title|type|tool|tool_name|arguments|parameters|options|input|command|url|wait_until)['"]?\s*:/i

const NOISY_LINE_PATTERNS = [
  /https:\/\/errors\.pydantic\.dev\//i,
  /\bvalidation errors?\b.*\bToolResult\b/i,
  /\bField required\b|\binput_type=dict\b/i,
  /^\s*(?:curl|wget)\s+[-\w]/i,
  /^\s*% Total\s+% Received\s+% Xferd\b/i,
  /^\s*<!DOCTYPE\b|^\s*<html\b|^\s*<head\b|^\s*<meta\b|^\s*<link\b/i,
  /\bE2B terminal-feil\b|\bCommand exited with code\b/i,
]

function isNoisyUserFacingLine(line: string): boolean {
  const trimmed = line.trim()
  if (!trimmed) return false
  if (RAW_TOOL_LINE_RE.test(trimmed)) return true
  if (RAW_JSON_LINE_RE.test(trimmed)) return true
  return NOISY_LINE_PATTERNS.some(pattern => pattern.test(trimmed))
}

export function cleanUserFacingText(value: string): string {
  if (!value) return ''

  const cleanedLines: string[] = []
  let inFencedBlock = false
  let removedAny = false

  for (const line of value.split('\n')) {
    if (line.trimStart().startsWith('```')) {
      inFencedBlock = !inFencedBlock
      cleanedLines.push(line)
      continue
    }

    if (!inFencedBlock && isNoisyUserFacingLine(line)) {
      removedAny = true
      continue
    }

    cleanedLines.push(line)
  }

  const cleaned = cleanedLines.join('\n').replace(/\n{3,}/g, '\n\n').trim()
  if (cleaned) return cleaned
  return removedAny
    ? 'Jeg har ryddet bort tekniske detaljer fra svaret. Prøv gjerne igjen hvis du vil at jeg skal forklare hva som skjedde.'
    : ''
}
